var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBxgyBundleGrayIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4 2C2.89543 2 2 2.89543 2 4V11C2 12.1046 2.89543 13 4 13H20C21.1046 13 22 12.1046 22 11V4C22 2.89543 21.1046 2 20 2H4ZM12 10C13.3807 10 14.5 8.88071 14.5 7.5C14.5 6.11929 13.3807 5 12 5C10.6193 5 9.5 6.11929 9.5 7.5C9.5 8.88071 10.6193 10 12 10Z",
    fill: "#808080"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22 16.5C22 17.0523 21.5523 17.5 21 17.5H3C2.44772 17.5 2 17.0523 2 16.5C2 15.9477 2.44772 15.5 3 15.5H21C21.5523 15.5 22 15.9477 22 16.5Z",
    fill: "#808080"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M21 22C21.5523 22 22 21.5523 22 21C22 20.4477 21.5523 20 21 20H3C2.44772 20 2 20.4477 2 21C2 21.5523 2.44772 22 3 22H21Z",
    fill: "#808080"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBxgyBundleGrayIcon);
export default __webpack_public_path__ + "static/media/bxgy-bundle-gray-icon.06c7f03301e03ec5ae41c8a0a0e0c8a7.svg";
export { ForwardRef as ReactComponent };